import { DuetStatus } from "./common-types"
import { DuetLangObject } from "./utils/language-utils"

export const DuetStringsDownloadLinkDefaults: DuetLangObject = {
  fi: "Linkki tallennetaan laitteellesi",
  sv: "Nedladdningslänk",
  en: "Download link",
}

export const DuetStringsExternalDefaults: DuetLangObject = {
  fi: "Avautuu uuteen ikkunaan",
  sv: "Öppnas i nytt fönster",
  en: "Opens in a new window",
}

export const DuetStringsLoadingDefaults: DuetLangObject = {
  fi: "Ladataan",
  sv: "Laddas",
  en: "Loading",
}

// Use with loading messages if completion is not otherwise communicated
export const DuetStringsCompleteDefaults: DuetLangObject = {
  fi: "Valmis",
  sv: "Färdig",
  en: "Complete",
}

export const DuetStringsPleaseWaitDefaults: DuetLangObject = {
  fi: "Odota, ole hyvä.",
  sv: "Vänligen vänta.",
  en: "Please wait.",
}

export const DuetStringsListStepOfTotal: DuetLangObject = {
  fi: "Lista jossa {total} kohtaa. Olet kohdassa {current}.",
  en: "List with {total} steps. You are on step {current}.",
  sv: "Lista med {total} steg. Du är på steg {current}.",
}

export const DuetStatusLabels: Record<DuetStatus, DuetLangObject> = {
  default: {
    fi: "Huomaa",
    en: "Please note",
    sv: "Observera",
  },
  // For success status there is no generally suitable label, so we use empty string
  success: {
    fi: "",
    en: "",
    sv: "",
  },
  danger: {
    fi: "Tärkeä varoitus",
    en: "Important warning",
    sv: "Viktig varning",
  },
  warning: {
    fi: "Varoitus",
    en: "Warning",
    sv: "Varning",
  },
}
